import React from "react";
import { motion } from "framer-motion";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-yellow-300 to-pink-400 text-white text-center px-4 py-6 mt-10 shadow-inner">
      <motion.p
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="text-sm sm:text-base font-semibold"
      >
        🌟 © {new Date().getFullYear()} Arabic learning hub — Made with ❤️ by Saad Charif Tribak
      </motion.p>
    </footer>
  );
}

export default Footer;
